import theme from '@liveauctioneers/caterwaul-components/lib/theme/theme';
import { createInfo } from '@liveauctioneers/hammer-ui-core/card/components/createInfo';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import SearchCardInfo from '@/components/GridItemCard/Card/CardOptions/CategorySearchCards/components/CardInfo/CardInfo';
import TimedPlusCardInfo from '@/components/GridItemCard/Card/CardOptions/TimedPlusItemCard/components/CardInfo/CardInfo';
import useIsWiderThan from '@/hooks/useIsWiderThan';
import { useAppSelector } from '@/redux/hooks';
import {
    getIsItemSummaryTimedPlusBiddingOpen,
    getItemSummaryIsBuyNowOnly,
} from '@/redux/modules/item/summary/itemSummary.selectors';
import { ItemSummary } from '@/types/item/ItemSummary';
import { useItemCardNavigation } from '@/utils/amplitude/experiments/hooks/useItemCardNavigation';

type DateAndHouseComponentProps = ItemSummary & {
    hasNewSimilarItemsIconCTA?: boolean;
    hasNewSimilarItemsTextCTA?: boolean;
    position: number;
};

export const DateAndHouseComponent = createInfo<DateAndHouseComponentProps>({
    className: 'line-clamp-0',
    useText: ({
        hasNewSimilarItemsIconCTA = false,
        hasNewSimilarItemsTextCTA = false,
        isPassed,
        isSold,
        isTimedPlusAuction,
        itemId,
        position,
        promoted,
    }) => {
        const { onNavigateInitiated } = useItemCardNavigation(itemId);

        const isMobile = !useIsWiderThan(theme.breakpoints.tabletNarrowWidthNum);
        const isTimedPlusBiddingOpen = useAppSelector((state) => getIsItemSummaryTimedPlusBiddingOpen(state, itemId));
        const isBuyNowOnly = useAppSelector((state) => getItemSummaryIsBuyNowOnly(state, itemId));
        const isOpenItem = !isPassed && !isSold && isTimedPlusBiddingOpen;

        return (
            <div
                className={cn('mt-xs', {
                    'px-xs pb-2xs smMin:px-sm': hasNewSimilarItemsIconCTA || hasNewSimilarItemsTextCTA,
                })}
            >
                {isTimedPlusAuction && !isBuyNowOnly ? (
                    <TimedPlusCardInfo
                        hasNewSimilarItemsIconCTA={hasNewSimilarItemsIconCTA}
                        hasNewSimilarItemsTextCTA={hasNewSimilarItemsTextCTA}
                        isMobile={isMobile}
                        isOpenItem={isOpenItem}
                        itemId={itemId}
                        onNavigate={(trigger) => {
                            onNavigateInitiated(trigger, { position, promoted });
                        }}
                    />
                ) : (
                    <SearchCardInfo
                        className={cn({
                            'pb-xs text-xs smMin:text-sm': hasNewSimilarItemsIconCTA || hasNewSimilarItemsTextCTA,
                        })}
                        hasNewSimilarItemsIconCTA={hasNewSimilarItemsIconCTA}
                        hasNewSimilarItemsTextCTA={hasNewSimilarItemsTextCTA}
                        itemId={itemId}
                        onNavigate={(trigger) => {
                            onNavigateInitiated(trigger, { position, promoted });
                        }}
                    />
                )}
            </div>
        );
    },
});
